import { MeshPhysicalMaterial, MeshStandardMaterial } from "three";

export function getModelVistaClearcoatSettings(record) {
    const properties = record?.Properties ?? [];
    const factor = properties.find((p) => p.Name === "clearcoatFactor");
    if (!factor) return null;
    const roughness = properties.find((p) => p.Name === "clearcoatRoughnessFactor");
    const clamp = (value) => Math.min(1, Math.max(0, Number(value) || 0));
    return {
        clearcoat: clamp(factor.FloatValue),
        clearcoatRoughness: clamp(roughness?.FloatValue)
    };
}

export function upgradeModelVistaPhysicalMaterial(baseMaterial) {
    const material = new MeshPhysicalMaterial();
    // PhysicalMaterial.copy expects physical-only fields; copy the standard
    // surface explicitly so textures, normal strength and roughness survive.
    if (baseMaterial?.isMeshStandardMaterial) {
        MeshStandardMaterial.prototype.copy.call(material, baseMaterial);
        material.defines = { ...material.defines, STANDARD: "", PHYSICAL: "" };
    } else if (baseMaterial?.color) {
        material.color.copy(baseMaterial.color);
    }
    return material;
}
